/**
 * Javascript for product pages
 */
(function (window, document, $, undefined) {
	'use strict';

	var $searchForm = $('.srch-form');
	var $searchAgainButton = $('.jh-search-results__search-block-search');
	var $categories = $('.jh-search-results__categories li');
	var $results = $('.jh-search-results__result');
	var $showing = $('.xNum');
	var $total = $('.xTotal');

	var chunkSize = parseInt( $showing.text() );
	var showResults = chunkSize;
	var loadedMoreTimestamp;

	$searchAgainButton.click(function(e) {
		var search_term = $('.jh-search-results__search-block-input').val();
		$searchForm.find('[name="s"]').val( search_term );
		$searchForm.find('form').submit();
	});


	$categories.click(function() {

		if ( !$(this).hasClass('active') ) {
			$categories.removeClass('active');
			$(this).addClass('active');
			showResults = chunkSize;
			filter();
		}
	});

	function filter() {

		$results.removeClass('active');

		var filtered_post_type = $categories.filter('.active').attr('data-filter');
		var $newResults = $results;

		if( filtered_post_type !== 'all' ) {
			$newResults = $results.filter( '[data-filter="'+filtered_post_type+'"]' );
		}

		var $newResultsLimited = $newResults.slice(0, showResults).addClass('active');

		$showing.text( $newResultsLimited.length );
		$total.text( $newResults.length );

		loadedMoreTimestamp = Date.now();
	}

	function loadMore() {
		showResults += chunkSize;
		filter();
	}

	$(window).scroll(function() {
		if( $results.length > 0 && loadedMoreTimestamp + 150 < Date.now() && showResults < parseInt( $total.text() ) ) {
			if( $(window).scrollTop() + $(window).height() >= $results.filter('.active').last().offset().top ){
				loadMore();
			}
		}
	});

	filter();

})( window, document, jQuery );
